export default __webpack_public_path__ + "static/media/Menu.44e32a3f.svg";